import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTAG_ID = 'GT-K46JD2F9';
const GA4_GTAG_ID = 'G-53JPDX2BSQ';

export const gtagEvents = {
    VIEW_ITEM: 'view_item',
    BEGIN_CHECKOUT: 'begin_checkout',
}

export const trackGtagEvent = (event, params = {}) => {
    if (process.env.REACT_APP_ENV !== 'prod') return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', event, params);
}

export const GTagPageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (process.env.REACT_APP_ENV !== 'prod') return;
        if (typeof window.gtag !== 'function') return;
        window.gtag('config', GTAG_ID, { page_path: location.pathname });
    }, [location]);

    return null;
}

export const captureGAClientId = () => {
  // GA4 can take a few milliseconds to initialize the 'get' command, so we retry if it fails
  const tryCapture = (retries = 0) => {
    if (typeof window.gtag === 'function') {
      window.gtag('get', GA4_GTAG_ID, 'client_id', (clientId) => {
        if (clientId) {
          window.sessionStorage.setItem('GA_CLIENT_ID', clientId);
        }
      });
    } else if (retries < 10) {
      // We retry up to 10 times with a delay of 500ms between attempts
      setTimeout(() => tryCapture(retries + 1), 500);
    }
  };

  tryCapture();
};